import request from '../../axios';

export const getOrderOtpCode = async () => {
  const {data} = await request.post(
    `/api/v2/payment/send-transaction-otp-code`,
  );

  return data;
};
